import Holiday from '@/classes/Holiday';
class HolidayCollection {
    holidays = [];
    constructor(holidayJson) {
        this.holidays = this.convertToHolidayObjectsFromJson(holidayJson);
    }
    convertToHolidayObjectsFromJson(holidayJson) {
        const holidayArray = [];
        holidayJson.forEach((holiday) => {
            const tempHoliday = new Holiday(holiday);
            holidayArray.push(tempHoliday);
        });
        return holidayArray;
    }
    getHolidayForDate(date) {
        const holidayRet = this.holidays.find((holiday) => {
            return window.dateHandler.formatDateNoTime(holiday.date) === window.dateHandler.formatDateNoTime(date);
        });
        return holidayRet;
    }
}
export default HolidayCollection;
